/**
 * App install dialog constants
 */
export const teamsDeepLinkUrlPathForAppInstall = '/l/app/';

/**
 * Calendar constants
 */
export const teamsDeepLinkUrlPathForCalendar = '/l/meeting/new';
export const teamsDeepLinkAttendeesUrlParameterName = 'attendees';
export const teamsDeepLinkStartTimeUrlParameterName = 'startTime';
export const teamsDeepLinkEndTimeUrlParameterName = 'endTime';
export const teamsDeepLinkSubjectUrlParameterName = 'subject';
export const teamsDeepLinkContentUrlParameterName = 'content';

/**
 * Call constants
 */
export const teamsDeepLinkUrlPathForCall = '/l/call/0/0';
export const teamsDeepLinkSourceUrlParameterName = 'source';
export const teamsDeepLinkWithVideoUrlParameterName = 'withVideo';

/**
 * Chat constants
 */
export const teamsDeepLinkUrlPathForChat = '/l/chat/0/0';
export const teamsDeepLinkUsersUrlParameterName = 'users';
export const teamsDeepLinkTopicUrlParameterName = 'topicName';
export const teamsDeepLinkMessageUrlParameterName = 'message';
